import CloseIcon from '@mui/icons-material/Close';

/**
 * TitleBar actions voor UmlSchemaDlg — alleen Close (New/Load/Save zijn body-knoppen,
 * zie screenshot-voorbeeld CsCodeGenFormHeader, niet titlebar-acties).
 * @param {function} onClose
 */
export const TITLE_BAR_ACTIONS = (onClose) => [{ icon: <CloseIcon sx={{ fontSize: 16 }} />, title: 'Close', onClick: onClose }];
